import { UndoOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const RotateControl = ({ onChange, disabled, value = false }) => {
  const { t } = useTranslation();
  const handleClick = useCallback(() => {
    onChange({ rotate: !value });
  }, [value, onChange]);

  return (
    <Button
      id="ol-control-rotate"
      data-testid="ol-control-rotate"
      title={t('components.rotate', 'Rotate')}
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
    >
      <UndoOutlined />
    </Button>
  );
};
